// extracted by mini-css-extract-plugin
export default {"wrapper":"Attachments_wrapper__ogZQB","group":"Attachments_group__EPkc1"};